export default "__VITE_PUBLIC_ASSET__160c1944__"